/* 鍾會（字士季） */
import { gd, landing, spMul } from '../../core/kit.ts';
import { defineHero, hook, U, S } from '../define.ts';

export default defineHero({
  id: 'zhonghui', name: '鍾會', sub: '字士季', faction: 'wei', role: '刺客', weapon: 'sword',
  look: { head: 'guan', eye: 'narrow', skin: '#f0d2b0', fx: '#9fe0c8', c: { plume: '#2f8a6a', cape: '#1e4a3a' } },
  skills: [
    ['謀叛', 'blink', '衝向目標並斬擊，造成 {80/125/170/215} 傷害；擊殺目標時立刻重置冷卻。', { x: { k: 'rebel', dmg: [80, 125, 170, 215] }, aim: U(500), wardHop: true, cd: [12, 11, 10, 9], mp: [60, 65, 70, 75], el: null }],
    ['效人書', 'stealth', '偽裝成最近的一名敵將 {10/14/18/22} 秒：外觀、名牌都變成他，敵方城寨、小兵與電腦不會主動攻擊鍾會；一出手就現形，這一擊傷害 +{40/60/80/100}%。', { x: { k: 'disguise', dur: [10, 14, 18, 22], amp: [40, 60, 80, 100] }, aim: S(0), cd: [30, 26, 22, 18], mp: 80, el: 'shadow' }],
    ['精練', 'passive', '每次施放技能後 3 秒內移速 +{4/6/8/10}%。', { pv: {}, sig: 'swift', ms: [4, 6, 8, 10] }],
    ['矯詔', 'command', '假傳詔令，指定一名敵將 {2/2.5/3} 秒倒戈：他會攻擊自己的隊友，期間造成的傷害與擊殺都算給鍾會。', { x: { k: 'forge', dur: [2, 2.5, 3] }, aim: U(500), cd: [100, 85, 70], mp: [150, 175, 200], el: 'shadow', shout: '太后遺詔在此！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    rebel(u, a, X) {
      const w = this.hopWard(u, a);
      if (w) { this.hopTo(u, w); return; } // 跳眼
      const t = this.xPick(u, a.pt, 150);
      if (!t) { this.xRefund(u, a); return; }
      const q = landing(u.x, u.y, t.x - Math.sign(t.x - u.x || u.f) * 50, t.y);
      this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; u.f = Math.sign(t.x - u.x) || u.f;
      this.damage(u, t, X.dmg * spMul(u), { magic: true, spell: true, stagger: 0.35 });
      this.fx({ k: 'spark', x: t.x, y: t.y - 30, col: u.spec.fx });
      if (!t.alive) { u.cd[a.i] = 0; this.tell(u, '謀叛：擊殺，冷卻重置', 'info'); }
      u.input.target = t;
    },
    disguise(u, a, X) {
      const foes = this.heroes(1 - u.team).filter((h) => h.alive).sort((p, q) => gd(u.x, u.y, p.x, p.y) - gd(u.x, u.y, q.x, q.y));
      const as = foes[0] || this.heroes(1 - u.team)[0];
      if (!as) { this.xRefund(u, a); return; }
      u.disguise = { spec: as.spec, name: as.name, until: this.t + X.dur, amp: X.amp };
      this.fx({ k: 'puff', x: u.x, y: u.y });
      this.tell(u, `效人書：偽裝成 ${as.name}`, 'info');
    },
    forge(u, a, X) {
      const t = this.xPick(u, a.pt, 150);
      if (!t || t.kind !== 'hero') { this.xRefund(u, a); this.tell(u, '矯詔：要指定敵將', 'warn'); return; }
      if (t.bf && t.bf.immune) { this.tell(u, '矯詔：對方魔法免疫', 'warn'); return; }
      t.mcTeam = t.team; t.mcT = this.t + X.dur; t.team = u.team; t.owner = u; t.act = null;
      if (t.input) { t.input.target = null; t.input.moveTo = null; t.input.skill = null; }
      this.say(`${u.name}：「${a.sk.shout}」${t.name} 倒戈！`, 'big');
      this.fx({ k: 'slam', x: t.x, y: t.y, col: '#b07cff' });
      this.later(X.dur, () => this.endForge(t));
    },
  },
  methods: {
    undisguise(u) { if (!u.disguise) return 0; const amp = u.disguise.until > this.t ? u.disguise.amp : 0; u.disguise = null; this.fx({ k: 'puff', x: u.x, y: u.y }); return amp; },
    endForge(t) {
      if (t.mcTeam == null) return;
      t.team = t.mcTeam; t.mcTeam = null; t.mcT = 0; t.owner = undefined; t.act = null;
      if (t.input) { t.input.target = null; t.input.moveTo = null; }
      if (t.ai) { t.ai.target = null; t.ai.mode = 'move'; }
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 矯詔：倒戈的人不會被原本的隊友打傷
    hook('damage.before', 60, function (c) { if (c.t.mcT > this.t && c.own.team === c.t.mcTeam) return true; }),
    // 效人書：偽裝中出手就現形，這一擊加傷
    hook('attack', 30, function (u, a, next) {
      if (u.disguise) {
        const amp = this.undisguise(u);
        if (amp && a.target) { const atk = u.atk; u.atk = atk * (1 + amp / 100); try { next(); } finally { u.atk = atk; } return; }
      }
      return next();
    }),
    // 效人書：放其他技能也會現形
    hook('cast.after', 10, function (u, i, sk) { if (u.disguise && !(sk && sk.x && sk.x.k === 'disguise')) this.undisguise(u); }),
    // 精練：放技能後加速
    hook('cast.after', 20, function (u, i, sk) { if (u.sg && u.sg.swift) this.addBuff(u, { id: 'swift', t: 3, ms: u.sg.swift.v('ms') / 100 }); }),
    hook('tick', 130, function (u, dt) { if (u.disguise && u.disguise.until <= this.t) u.disguise = null; }),
    // 效人書：偽裝中，城寨、小兵、黃巾賊、電腦都不會主動把他當敵人（真人玩家仍然打得到）
    hook('isEnemy.no', 10, function (u, t) {
      return t.disguise && t.disguise.until > this.t && !(u.kind === 'hero' && u.human);
    }),
    // 矯詔：倒戈中自動攻擊最近的（原本的）隊友，不聽玩家或電腦的指令
    hook('control.pre', 10, function (u, dt) {
      if (u.mcT > this.t && u.alive) {
        const I = u.input;
        let best = null, bd = 900;
        for (const o of this.units) if (o.alive && o.team === u.mcTeam && !o.structure && o.kind !== 'ward' && o.kind !== 'cart') { const d = gd(u.x, u.y, o.x, o.y) - (o.kind === 'hero' ? 150 : 0); if (d < bd) { bd = d; best = o; } }
        I.target = best; I.moveTo = null; I.skill = null; I.amove = null; I.mx = I.my = 0; I.attack = false; I.item = null;
      }
    }),
  ],
  // 電腦什麼時候放這招
  ai: {
    rebel: ({ w, u, t, d, hero, hpR, foeHeroes }) => !!t && d < 500 && (hero || t.hp < 200),
    disguise: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d > 350 && d < 900 && !u.disguise,
    forge: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 480 && w.units.some((o) => o !== t && o.alive && o.kind === 'hero' && o.team === t!.team && gd(o.x, o.y, t!.x, t!.y) < 600),
  },
});
